import { takeEvery, call, put, fork } from 'redux-saga/effects';
import cdmApi, { resolveError } from 'services/cdmApi';
import {
  requestCdmTranslation,
  receiveCdmTranslation,
  errorCdmTranslation,
} from 'actions/cdmTranslationActions';

export function* requestDataTask(action: ReturnType<typeof requestCdmTranslation>): any {
  const { keys, params } = action.payload;

  try {
    const response = yield call(cdmApi.get, `/translation/web?${keys.join('&')}`, {
      params,
    });

    yield put(receiveCdmTranslation(response.data));
  } catch (error) {
    const err = resolveError(error);
    yield put(errorCdmTranslation(err));
  }
}

export function* watchRequestData() {
  yield takeEvery(requestCdmTranslation.type, requestDataTask);
}

export default function* dataSaga() {
  yield fork(watchRequestData);
}
